import React, {useState, useEffect, createContext} from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import loadable from '@loadable/component';
import './App.css';
import useSWR from "swr";
import fetcher from "./pages/superUser/fetcher";
export const GlobalUserState = createContext<any>(null);

const Login = loadable(() => import('./pages/Login/Main'))
const Admin = loadable(() => import('./pages/Admin/admin'))
const SuperAdmin = loadable(() => import('./pages/superUser/superAdmin'))

const App = () => {
    const [user, setUser] = useState(null)

    const {data} = useSWR('/user/',fetcher,{
        revalidateOnFocus: true,
    });

    useEffect(()=>{
        if(data){
            setUser(data)
        }
    },[data])
  return (

      <BrowserRouter>
          <GlobalUserState.Provider value={{
              setUser
          }}>
            <Switch>
              <Route exact path={"/"} render={() => {
                  if(user && user.is_admin) {
                    return user.is_superuser ? (
                        <Redirect to={"/superAdmin"}/>
                    ):(
                        <Redirect to={"/admin"}/>
                    )
                  }else{
                      return <Login/>
                }
              }}/>

              <Route path={"/admin"} component={Admin}/>


              <Route path={"/superAdmin"} component={SuperAdmin}/>
            </Switch>
          </GlobalUserState.Provider>
      </BrowserRouter>

  );
}

export default App;
